import React from "react";
import svg151 from "../../../../assets/svg/svg151.svg";
import svg152 from "../../../../assets/svg/svg152.svg"; 

function BuyTokens({ accountNumber }) {
  return (
    <div className="rounded-[0.75rem] bg-white shadow-[0_0_0_1px_rgba(0,0,0,0.05)] p-[0.75rem] "> 
      <div className="flex justify-between items-start">
        <div className="flex flex-col gap-[0.75rem]">
          <div className="flex items-center gap-[0.5rem]">
            <div className="w-[1.5rem] h-[1.5rem] rounded-[0.375rem] bg-[#1E191B] flex items-center justify-center">
              <img src={svg151} alt="svg151" />
            </div>
            <span className="text-[#0F172A] font-[500] font-lexendS text-[0.875rem] leading-[1.5rem]">
              Buy KPLC Tokens
            </span>
          </div>

          <div className="flex items-center gap-[0.44rem] rounded-[624.9375rem] py-[0.125rem] px-[0.5rem] bg-[#EDEDF1] w-fit">
            <img src={svg152} alt="svg152" className="w-[0.75rem] h-[0.75rem]" />
            <span className="text-[#4F4770] text-[0.625rem] font-[500] leading-[0.9375rem] font-lexendS">
              {accountNumber || "060387691"}
            </span>
          </div>
        </div>

        <div className="py-[0.125rem] px-[0.5rem] rounded-[624.9375rem] bg-[#EDEDF1] text-[#4F4770] text-[0.625rem] font-[500] leading-[0.9375rem] font-lexendS">
          Preview
        </div>
      </div>
    </div>
  );
}

export default BuyTokens;
